import { Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { CostFigure } from "./cost-figure"

export function AnnualCostCell({ cost, currency }) {
    if (cost == null) {
        return (
            <Typography variant="body2" color="text.secondary">
                {"\u2014"}
            </Typography>
        )
    }

    return (
        <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={1}>
            <Iconify
                icon="majesticons:money-line"
                width={20}
                height={20}
                sx={{ color: "primary.main", flexShrink: 0 }}
            />
            <CostFigure
                value={cost}
                currencySymbol={currency}
                sx={{ fontSize: 16, fontWeight: 600 }}
                dataCy="scenario-annual-cost"
            />
        </Stack>
    )
}
